<template>
	<div class="bg-gray-50 dark:bg-transparent pt-8 relative dark:bg-jackpot dark:bg-cover dark:bg-left-top" id="jackpots">
	    <div class="mt-10 pb-8">
	        <div class="relative">
	            <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
	                <div class="max-w-4xl mx-auto">
	                    <dl class="rounded-lg bg-white dark:bg-gray-900 shadow-lg grid grid-cols-2">
	                        <div class="flex flex-col border-b border-gray-100 dark:border-gray-800 p-6 text-center sm:border-0 sm:border-r">
	                            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500 dark:text-white">
	                                Daily Jackpot
	                            </dt>
	                            <dd class="order-1 text-5xl font-extrabold text-gray-800 dark:text-racing-stars-yellow">
	                                <counter ref="dailyJackpot" :startAmount="0" :endAmount="page.props.value.racingstars.dailyJackpot / 100" :duration="duration(page.props.value.racingstars.dailyJackpot / 100)" prefix="&pound;" @finished="restartDaily()" />
	                            </dd>
	                        </div>
	                        <div class="flex flex-col border-t border-b border-gray-100 dark:border-gray-800 p-6 text-center sm:border-0 sm:border-l sm:border-r">
	                            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-500 dark:text-white">
	                                Weekly Jackpot
	                            </dt>
	                            <dd class="order-1 text-5xl font-extrabold text-gray-800 dark:text-racing-stars-yellow">
	                                <counter ref="weeklyJackpot" :startAmount="0" :endAmount="page.props.value.racingstars.weeklyJackpot / 100" :duration="duration(page.props.value.racingstars.weeklyJackpot / 100)" prefix="&pound;" @finished="restartWeekly()" />
	                            </dd>
	                        </div>
	                    </dl>
	                </div>
	            </div>
	        </div>
	    </div>
	    <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
	        <div class="max-w-4xl mx-auto text-center">
	            <h2 class="text-3xl font-extrabold text-gray-900 dark:text-racing-stars-yellow sm:text-4xl">
	                Win Both Daily &amp; Weekly Jackpots
	            </h2>
	            <p class="mt-3 text-xl text-gray-500 dark:text-white sm:mt-4">
	                The more people playing, the bigger the jackpots. Every token contributes to the daily and weekly prizes with a guaranteed daily minimum jackpot of &pound;50 and a guranteed weekly minimum jackpot of &pound;100. Once the relevant number of entries have been made to hit the minimum levels you will start to see the jackpot amounts grow all the time.
	            </p>
	        </div>
	    </div>
	</div>
</template>

<script>
	import { ref } from 'vue'
	import { usePage } from '@inertiajs/inertia-vue3'
	import counter from 'vue3-autocounter';

	export default {
		setup() {

			const page = usePage()

			const dailyJackpot = ref(null)

			const weeklyJackpot = ref(null)

	        /**
	         * Formatter function required to format currencies/prices correctly.
	         * 
	         * @type {Intl}
	         */
	        const formatter = new Intl.NumberFormat('en-GB', {
	            style: 'currency',
	            currency: 'GBP',
	        })

	        const restartDaily = () => {
	        	if (dailyJackpot.value) {
		        	dailyJackpot.value.reset()
		        	dailyJackpot.value.start()
		        }
	        }

	        const restartWeekly = () => {
	        	if (weeklyJackpot.value) {
		        	weeklyJackpot.value.reset()
		        	weeklyJackpot.value.start()
		        }
	        }

	        const duration = (jackpot) => {
	        	return (parseInt(jackpot) / 100) * 16
	        }

			return {
				page,
				formatter,
				dailyJackpot,
				weeklyJackpot,
				restartDaily,
				restartWeekly,
				duration,
			}

		},

		components: {
			counter,
		}
	}
</script>
